module.exports = __webpack_public_path__ + "img/monitor-icon.e6f81070.svg";